import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from "rxjs"
import { NewinterviewreviewComponent } from './newinterviewreview/newinterviewreview.component';

@Injectable()
export class AppService {

  constructor(private http: Http) { }


sendUserData()
{
 return this.http.post('http://localhost/interview/interviewfeedback.php',{name:'Megha',city: 'Pune'})
.map(
    (response: Response)=>
      response.json()
    
);
}

}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/app.service.ts